import React from 'react'
import { Route, Redirect, RouteComponentProps } from 'react-router'
import {  RouteComponent } from './components'
import LayoutContext, { ILayoutContext } from './LayoutContext'
import {SiderMenu} from './components/SiderMenu'
import {GlobalHeader} from './components/GlobalHeader'
import LayoutBase from './LayoutBase'
import setWatermark from './WaterMark'

interface IProtectedProps extends RouteComponentProps<any> {
  user: IUser
  routeData: IRoute[]
}
export default class extends React.PureComponent<IProtectedProps> {
  state = {collapsed:false}
  refContentDiv = React.createRef<HTMLDivElement>()

  componentDidUpdate() {
   this.handleContentChange()
  }

  handleContentChange = () =>{
    let { user } = this.props
    setWatermark(user.userName, this.refContentDiv.current, {
      width: 150,
      height: 150
    })
  }

  renderLayout = (layoutContext: ILayoutContext) => {
    let { routeData, user } = this.props
    return (
      <div className="app-index-layout">
        <SiderMenu/>
        <div className="app-index-content-layout">
          <GlobalHeader/>
          <div className="app-index-content">
            <div className="app-component-content" 
            key={layoutContext.collapsed?1:0} 
            ref={this.refContentDiv}>
              {this.renderRoute()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderRoute = () => {
    let { routeData, user } = this.props
    return routeData.map(route => {
      let RouteContainer: any = Route
      return (
        <RouteContainer
          key={route.path}
          path={route.path}
          render={(props: any) => (
            <RouteComponent {...props} route={route} user={user} />
          )}
          exact={true}
          redirectPath="/exception/403"
        />
      )
    })
  }
  render() {
    let { user } = this.props
    if (user.isLogin) {
      return (
        <LayoutBase {...this.props}>
          <LayoutContext.Consumer>{this.renderLayout}</LayoutContext.Consumer>
        </LayoutBase>
      )
    }
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: this.props.location }
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/ProtectedLayout.tsx